import { MailMergeTemplateType } from '@/shared/schema/globalTypes';
import { useMutation, useQuery } from '@vue/apollo-composable';
import GET_INVOICE_TEMPLATE from './get-invoice-template.graphql';
import GET_TEMPLATE_NAMES from '@/shared/graphql/get-template-names.graphql';
import SAVE_INVOICE_TEMPLATE from './save-invoice-template.graphql';
import { computed } from 'vue';
export function useGetTemplateNames() {
    const { result, loading, onResult } = useQuery(GET_TEMPLATE_NAMES);
    const names = computed(() => result.value?.getMailMergeTemplateNames ?? []);
    return {
        names,
        loading,
        onLoaded: onResult
    };
}
export function useGetTemplate(props) {
    const { result, loading, onResult } = useQuery(GET_INVOICE_TEMPLATE, {
        campaignId: props.campaignId,
        pledgeId: props.pledgeId,
        department: props.department
    });
    const template = computed(() => result.value?.getMailMergeTemplate ?? null);
    return {
        template,
        loading,
        onLoaded: onResult
    };
}
export function useSaveTemplate(props) {
    const { mutate } = useMutation(SAVE_INVOICE_TEMPLATE, {
        refetchQueries: ['GetInvoiceTemplate']
    });
    function saveTemplate(data) {
        return mutate({
            template: {
                type: MailMergeTemplateType.Invoice,
                templateName: data.templateName,
                campaignId: props.campaignId,
                pledgeId: props.pledgeId,
                department: props.department,
                body: data.body,
                firstLine: data.firstLine,
                paymentNotes: data.paymentNotes,
                fundraiserId: data.fundraiserId,
                logoUrl: data.logoUrl,
                donationFormUrl: data.donationFormUrl,
                salutationType: data.salutationType,
                emailText: data.emailText,
                removeSignature: data.removeSignature
            }
        });
    }
    return { saveTemplate };
}
